import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.SearchOffers__V1_GetOffersByPin, string];

export const getQueryKey = (pinId: QueryKey[1]): QueryKey => [EQueryKeys.SearchOffers__V1_GetOffersByPin, pinId];
